const camelToTitle = (s) => {
	const result = s.replace(/([A-Z])/g, ' $1').trim()
	return result.charAt(0).toUpperCase() + result.slice(1)
}

export default camelToTitle
